import { createSlice } from "@reduxjs/toolkit";

const initialStaffUsersState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  games: [],
  PANcardFile: "",
  bankDetailFile: "",
  consentAgreementFile: "",
  signupcode: [],
  roleList: [],
  usersCount: null,
  wallet: null,
  walletrmg: null,
  exportData:null,
  influencerFetchedEdit: {},
  kpisForEdit: {},
  logs: {
    entities: [],
    totalCount: 0,
  },
  queries: {
    entities: [],
    totalCount: 0,
  },
  contacts: {
    entities: [],
    totalCount: 0,
  },
  contests: {
    entities: [],
    totalCount: 0,
  },
  tournamnets: {
    entities: [],
    totalCount: 0,
  },
  transactions: {
    entities: [],
    totalCount: 0,
  },
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};
export const affiliateprogramnewSlice = createSlice({

  name: "affiliateprogramNew",
  initialState: initialStaffUsersState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    clearfetchStaffUsers: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.entities = [];
      state.totalCount = 0;
    },
    emptyList: (state, action) => {
      state.error = null;
      state.entities = [];
      state.totalCount = 0;
    },

    permissionsFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.permissionsEntities = entities;
      state.totalCount = totalCount;
    },
    // getstaffUserById
    influencerFetched: (state, action) => {
      state.actionsLoading = false;
      state.influencerFetchedEdit = action.payload.influencerFetchedEdit;
      state.error = null;
    }, 
    kpisFetched: (state, action) => {
      state.actionsLoading = false;
      state.kpisForEdit = action.payload.kpisForEdit;
      state.error = null;
    },

    roleFetched: (state, action) => {
      state.actionsLoading = false;
      state.roleList = action.payload.roleList;
      state.error = null;
    },

 
    // findstaffUsers
    AffliateprogramlistFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },   
    AffliateprogramlistFetchedload: (state, action) => {
      // const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      // state.entities = entities;
      // state.totalCount = totalCount;
    },
    staffUsersFetchedExport: (state, action) => {
      const { exportData} = action.payload;
      state.listLoading = false;
      state.error = null;
      state.exportData = exportData;
     // state.totalCount = totalCount;
    },
     // appUsersFetched
     appUsersFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },

    // deleteRequestFetched
    deleteRequestFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },

    // permissionsFetched
    permissionsFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.permissionsEntities = entities;
      state.totalCount = totalCount;
    },
  
     CompanyDropdownList: (state, action) => {
      const { companyDropdownList } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.totalCount = 0;
      state.companyDropdownList = companyDropdownList;
    },

    RoleDropdownList: (state, action) => {
      const { roleDropdownList } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.totalCount = 0;
      state.roleDropdownList = roleDropdownList;
    },

    signupcode: (state, action) => {
      const { totalCount, entities } = action.payload;
      // console.log(entities)
      state.listLoading = false;
      state.error = null;
      state.signupcode = entities;
      // state.totalCount = totalCount;
    },
  
    // dashboard main
    mainDashboardUserFetched: (state, action) => {
      const { entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.usersCount = entities;
    },

    mainDashboardFetchedWallet: (state, action) => {
      const { walletData } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.wallet = walletData;
    },

    mainDashboardFetchedWalletRmg: (state, action) => {
      const { walletDataRmg } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.walletrmg = walletDataRmg;
    },

    // findstaffUsers
    userLogFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.logs.entities = entities;
      state.logs.totalCount = totalCount;
    },
    // findstaffUsers
    userQueriesFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.queries.entities = entities;
      state.queries.totalCount = totalCount;
    },
    userContactsFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.contacts.entities = entities;
      state.contacts.totalCount = totalCount;
    },
    // findstaffUsers
    userContestsFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.contests.entities = entities;
      state.contests.totalCount = totalCount;
    },
    // findstaffUsers
    userTournamnetsFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.tournamnets.entities = entities;
      state.tournamnets.totalCount = totalCount;
    },
    // userTransactionsFetched
    userTransactionsFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.transactions.entities = entities;
      state.transactions.totalCount = totalCount;
    },
    // influencerCreated
    influencerCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities = [];
      // state.entities.push(action.payload.staffUser);
    },
   
    // updatestaffUser
    influencerUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = [];
      // state.entities = state.entities.map(entity => {
      //   if (entity._id === action.payload.staffUser._id) {
      //     return action.payload.staffUser;
      //   }
      //   return entity;
      // });
    },    
    kpiliststatusUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = [];
      // state.entities = state.entities.map(entity => {
      //   if (entity._id === action.payload.staffUser._id) {
      //     return action.payload.staffUser;
      //   }
      //   return entity;
      // });
    },  
    kpiUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = [];
      // state.entities = state.entities.map(entity => {
      //   if (entity._id === action.payload.staffUser._id) {
      //     return action.payload.staffUser;
      //   }
      //   return entity;
      // });
    },

    imageUploaded: (state, action) => {
      const { entities, imageField } = action.payload;
    
      // Clear any existing errors
      state.error = null;
    
      // Ensure imageField exists and matches a state property
      if (imageField && Object.prototype.hasOwnProperty.call(state, imageField)) {
        state[imageField] = entities; // Update the state with the new image entities
      } else {
        console.error(`Image field ${imageField} does not exist in state`);
        // Optionally, handle the case where imageField does not match any state property
        state.error = "Invalid image field";
      }
    },
    
    affiliatedashboardList: (state, action) => {
      const { totalCount, entities } = action.payload;
      console.log("totalCount, entities slice",totalCount, entities)
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    influenceruserExport: (state, action) => {
      const { exportData } = action.payload;
      // state.listLoading = false;
      // state.error = null;
      state.exportData = exportData;
    },  
    // staffUsersUpdateState
  
  }
});
